export default __webpack_public_path__ + "static/media/icon-srt-file.e709a09c.svg";